'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionItemBody = function AccordionItemBody(props) {
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)("panel-collapse", "collapse", { "in": props.isActive || props.expandAll }) },
    _react2.default.createElement(
      'div',
      { className: 'panel-body' },
      props.children
    )
  );
};

AccordionItemBody.propTypes = {
  isActive: _propTypes2.default.bool,
  expandAll: _propTypes2.default.bool
};

AccordionItemBody.defaultProps = {
  isActive: false
};

exports.default = AccordionItemBody;